import * as React from 'react';
import * as PropTypes from 'prop-types';

import {Box} from '@mantine/core';

export const UserFullName = ({ user }) => {
    let fullName = '';

    let firstName = user['emailAddress'];
    let lastName = '';

    if (
        typeof user['firstName'] !== 'undefined' &&
        user['firstName'].toString().length > 0
    ) {
        firstName = user['firstName'];
    }
    if (
        typeof user['lastName'] !== 'undefined' &&
        user['lastName'].toString().length > 0
    ) {
        lastName = user['lastName'];
    }

    fullName = [firstName, lastName].join(' ');

    return <Box>{fullName}</Box>;
};

UserFullName.propTypes = {
    user: PropTypes.object.isRequired,
};
